export default __webpack_public_path__ + "static/media/HUGO-06.04a38fc0.png";